import { render, staticRenderFns } from "./Home-item-detalle.vue?vue&type=template&id=276fc16a&scoped=true&lang=pug"
import script from "./Home-item-detalle.vue?vue&type=script&lang=js"
export * from "./Home-item-detalle.vue?vue&type=script&lang=js"
import style0 from "./Home-item-detalle.vue?vue&type=style&index=0&id=276fc16a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276fc16a",
  null
  
)

export default component.exports